import { Component, OnDestroy, OnInit } from '@angular/core';
import { DwAction, DwActionButtonComponent, DwActionPreference, DwActionType, DwDecoratorType, DwMetaDataConfigContext, DwMetaDataListConfigContext } from '@devwareapps/devware-cap';
import { DwGridQuickSearchConfig } from '@devwareapps/devware-cap/devware-ui-metadata/grid/actions/services/dw-grid-quick-search-action/model/dw-grid-quick-search-config.model';
import { TimerEntity, TimersMetaDataItemNames } from '../../meta-data/timers-meta-data.service';
import { TimerUtilService } from '../../services/timer-util.service';
import { TimerAutoRefreshActionConfigComponent } from './config/timer-auto-refresh-action-config/timer-auto-refresh-action-config.component';
import { TimerAutoRefreshConfig } from './model/timer-auto-refresh-config.model';


@DwAction({
  keyName: 'timersAutoRefresh',
  display: 'Timers Auto Refresh',
  actionType: DwActionType.listAction,
  decoratorType: DwDecoratorType.component,
  isGlobal: false,
  parentItemName: TimersMetaDataItemNames.Timer,
  allowOnce: true,
  configComponent: TimerAutoRefreshActionConfigComponent
})
@Component({
  selector: 'app-timer-auto-refresh-action',
  template: `
    <div class="action">
      <label style="color:white">Auto Refresh<label>

      <dw-yesno [(ngModel)]="autoRefreshEnabled" (ngModelChange)="setupAutoRefresh()"></dw-yesno>
    <div>
  `,
  styles: [`
    .radio-container {
        margin:5px;
    }

    .radio-item {
        margin-left:5px;
        margin-top:-6px;
    }

  `]
})
export class TimerAutoRefreshActionComponent implements DwActionButtonComponent<TimerAutoRefreshConfig, DwMetaDataListConfigContext>, OnDestroy {
  actionPreference: DwActionPreference<TimerAutoRefreshConfig>;
  actionContext?: DwMetaDataListConfigContext;
  autoRefreshEnabled: boolean = false;
  intervalHandle: any;
  previousLastTimer: TimerEntity; 

  constructor(private timerUtilService: TimerUtilService) { }
  
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }
  }
  
  setupComponent() {
    this.autoRefreshEnabled = this.actionPreference.actionConfig?.autoRefreshEnabledDefault || false;

    this.setupAutoRefresh();
  }
  
  setupAutoRefresh() {
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }

    if (this.autoRefreshEnabled) {
      const interval = this.actionPreference?.actionConfig?.refreshIntervalSeconds * 1000 || 15000;

      this.intervalHandle = setInterval(() =>{
        this.doRefresh();
      }, interval);
    }
  }

  doRefresh() {
    if (!this.autoRefreshEnabled) {
      return;
    }

    if (!this.actionPreference?.actionConfig?.useBackgroundQuery) {
      this.actionContext.metaDataListApi.refreshData();
      return;
    }

    // Get last modified record
    this.timerUtilService.getLastModifiedTimer()
      .subscribe(currentLastTimer => {
        if (this.previousLastTimer?.ModifiedByDateTime == currentLastTimer.ModifiedByDateTime) {
          console.log(`Last Timer not modified from ${this.previousLastTimer?.ModifiedByDateTime}`);

          return;
        }

        if (this.previousLastTimer) {
          this.actionContext.metaDataListApi.refreshData();
        }

        this.previousLastTimer = currentLastTimer;
      });
  }

}
